// ------ actions
export const ACTION_GEO_CONFIG_LOADED = 'ACTION_GEO_CONFIG_LOADED';

export const ACTION_GEO_CONFIG_LOADING = 'ACTION_GEO_CONFIG_LOADING';

export const ACTION_GLOBAL_CONFIG_LOADED = 'ACTION_GLOBAL_CONFIG_LOADED';

export const ACTION_GLOBAL_CONFIG_LOADING = 'ACTION_GLOBAL_CONFIG_LOADING';

export const ACTION_USER_CONFIG_LOADED = 'ACTION_USER_CONFIG_LOADED';

export const ACTION_USER_CONFIG_LOADING = 'ACTION_USER_CONFIG_LOADING';
